import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import data from "../../../Data/staffData/staffData.json";

export default function StaffDetail() {
  const { slug } = useParams();
  const person = data.find((p) => p.slug.toString() === slug);

  if (!person) {
    return <p>Сотрудник не найден</p>;
  }

  return (
    <section className="contacts education staff-detail">
      <Breadcrumbs />
      <div className="staff-detail__wrapper">
        <div className="staff-detail__photo">
          <img src={person.photo} alt={person.name} />
        </div>
        <div className="staff-detail__info">
          <h1 className="staff-detail__name">{person.name}</h1>
          <h4 className="staff-detail__position">{person.position}</h4>
          {person.bio && (
            <div className="staff-detail__bio">
              {person.bio.map((block, index) => (
                <p key={index}>{block}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
